export default __webpack_public_path__ + "static/media/PayPal-Color.517f6374.svg";